import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import Story from '../views/Story.vue';
import Mail from '../views/Mail.vue';
import Reserve from '../views/Reserve';
import Appoint from '../views/Appoint';

// import MgVideo from '../views/MgVideo.vue';
// import Star from '../views/Star.vue';
// import YD from '../views/YD.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/story',
    name: 'story',
    component: Story,
  },
  {
    path: '/mail',
    name: 'mail',
    component: Mail,
  },
  {
    path: '/reserve',
    name: 'reserve',
    component: Reserve,
  },
  {
    path: '/appoint',
    name: 'appoint',
    component: Appoint,
  },
  { path: '*', redirect: { name: 'home' } },
];

const router = new VueRouter({
  routes,
});

export default router;
